import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Vehicles from "@/pages/Vehicles";
import Offers from "@/pages/Offers";
import Reviews from "@/pages/Reviews";
import ContactPage from "@/pages/ContactPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/vehicules" element={<Vehicles />} />
              <Route path="/offres" element={<Offers />} />
              <Route path="/avis" element={<Reviews />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </LanguageProvider>
    </div>
  );
}

export default App;
